import React, { useRef, useEffect, useState } from "react";

const Hero = ({ openAIChat }) => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <section
            ref={sectionRef}
            id="home"
            className={`
                min-h-screen 
                flex flex-col
                justify-center
                items-center
                text-center
                px-4 sm:px-6
                py-12 sm:py-0
                bg-gray-100
                dark:bg-gray-900
                transition-all
                ${isVisible ? "animate-fadeIn" : "opacity-0"}
            `}
        >
            <div className="max-w-4xl px-4 sm:px-6">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 dark:text-white mb-3 sm:mb-4">
                    Hi, I&apos;m <span className="text-blue-500 block sm:inline">OUFFA ABDELLAH-オウファアブデラ</span>
                </h1>
                <h2 className="text-xl sm:text-2xl text-gray-600 dark:text-gray-300 mb-4 sm:mb-6">
                    Mid-Senior Full-Stack Developer
                </h2>
                <p className="text-base sm:text-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto leading-relaxed mb-6 sm:mb-8">
                    I specialize in building scalable, high-performance web applications with{" "}
                    <strong>React</strong>, <strong>Django</strong>, and <strong>Node.js</strong>.
                </p>
                <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                    <a
                        href="#projects"
                        className="px-4 py-2 sm:px-6 sm:py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-all text-sm sm:text-base"
                    >
                        View My Work
                    </a>
                    <a
                        href="#contact"
                        className="px-4 py-2 sm:px-6 sm:py-3 border border-blue-500 text-blue-500 font-semibold rounded-lg hover:bg-blue-500 hover:text-white transition-all text-sm sm:text-base"
                    >
                        Contact Me
                    </a>

                    {/* ✅ AI Chat Assistant Button */}
                    <button
                        onClick={() => {
                            console.log("AI Chat Assistant Clicked");
                            openAIChat();
                        }
                        }
                        className="px-4 py-2 sm:px-6 sm:py-3 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600 transition-all text-sm sm:text-base"
                    >
                        💡 AI Chat Assistant
                    </button>
                </div>
            </div >
        </section >
    );
};

export default Hero;